/*! @azure/msal-common v16.10.0 2026-06-23 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "16.10.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
